import { LoadCssResolver, LoadScriptResolver } from '@b2b/common/resolvers';
import { ApiService } from '@b2b/common/services/api/types';
import { PermissionsService } from '@b2b/common/services/permissions';
import { TODO } from '@b2b/types/core';
import uiRouter, { IInjectable, StateProvider } from '@uirouter/angularjs';
import angular from 'angular';
import { MembershipLevelsCreateControllerModule } from './controllers/MembershipLevelsCreateController';

function MembershipLevelCollectionsResolver(): IInjectable {
  return [
    'PermissionsService',
    'HelpersService',
    'ApiService',
    function (PermissionsService: PermissionsService, HelpersService: TODO, ApiService: ApiService) {
      if (PermissionsService.check('MEMBERSHIP_LEVEL_COLLECTION_VIEW')) {
        return ApiService.membership.categories.collection.list(
          HelpersService.getPaginator({ sortField: 'displayOrder' })
        );
      }

      return { data: false };
    },
  ];
}

export const MembershipLevelsCreateView = angular
  .module('acme.view.application.membership.levels.create', [
    uiRouter,
    'ui.bootstrap',
    'acme.common.service.api',
    'acme.common.service.helpers',
    'acme.common.service.permissions',
    'acme.common.directive.upload',
    'acme.common.directive.integer',
    'acme.common.directive.numeric',
    MembershipLevelsCreateControllerModule,
  ])
  .config(function config($stateProvider: StateProvider) {
    $stateProvider.state({
      name: 'application.membership.levels.create',
      url: '/create?group&groupId&auxiliary',
      views: {
        'subview-main@application': {
          templateUrl: 'views/application/views/membership/levels/create/create.tpl.html',
          controller: 'MembershipLevelsCreateController',
        },
      },
      data: {
        pageTitle: 'Create Membership Level',
        permissions: ['MEMBERSHIP_CATEGORY_CREATE'],
        enablePreferences: true,
      },
      resolve: {
        bootstrap: LoadScriptResolver({ id: 'bootstrap-js', url: '/assets/bootstrap.min.js' }),
        summernote: LoadScriptResolver({ id: 'summernote-js', url: '/assets/summernote.min.js' }),
        summernoteCss: LoadCssResolver({ id: 'summernote', url: '/assets/summernote.css' }),
        MembershipLevelCollections: MembershipLevelCollectionsResolver(),
      },
    });

    $stateProvider.state({
      name: 'application.membership.levels.edit',
      url: '/:categoryId/edit',
      views: {
        'subview-main@application': {
          templateUrl: 'views/application/views/membership/levels/create/create.tpl.html',
          controller: 'MembershipLevelsCreateController',
        },
      },
      data: {
        pageTitle: 'Edit Membership Level',
        permissions: ['MEMBERSHIP_CATEGORY_UPDATE'],
        enablePreferences: true,
      },
      resolve: {
        bootstrap: LoadScriptResolver({ id: 'bootstrap-js', url: '/assets/bootstrap.min.js' }),
        summernote: LoadScriptResolver({ id: 'summernote-js', url: '/assets/summernote.min.js' }),
        summernoteCss: LoadCssResolver({ id: 'summernote', url: '/assets/summernote.css' }),
        MembershipLevelCollections: MembershipLevelCollectionsResolver(),
      },
    });
  }).name;
